import { Avatar, Box, ModalSlideshow } from '@dev-spendesk/grapes';
import { useState } from 'react';
import { Trans } from 'react-i18next';

import { useTranslation } from 'common/hooks/useTranslation';
import { useUserRoles } from 'modules/app/hooks/useUserRoles';
import { LocalStorageKey } from 'src/core/constants/storage';

import { useCompany } from '../../../../modules/app/hooks/useCompany';
import { useIsIwtEnabled } from '../../../../modules/invoices/transfer/hooks/api/useIsIwtEnabled';

export const InternationalWireTransferFeaturePostAdoptionModal = () => {
  const { t } = useTranslation('global');

  const userRoles = useUserRoles();

  const isTargetRole =
    userRoles.isAccountOwner || userRoles.isAdmin || userRoles.isController;

  const hasBeenClosed = localStorage.getItem(
    LocalStorageKey.IwtAdoptionModalClosedDate,
  );

  const isIwtEnabled = useIsIwtEnabled();

  const company = useCompany();

  const isEea = company.currency === 'EUR';

  const isHomepage = window.location.pathname.includes('/home');

  const [isOpen, setIsOpen] = useState(
    isHomepage && isTargetRole && !hasBeenClosed && isIwtEnabled,
  );

  const closeModal = () => {
    setIsOpen(false);
    localStorage.setItem(
      LocalStorageKey.IwtPostAdoptionModalClosedDate,
      new Date().toISOString(),
    );
  };

  const onDoneClick = () => {
    localStorage.setItem(
      LocalStorageKey.IwtPostAdoptionModalClosedDate,
      new Date().toISOString(),
    );

    window.location.href = `/app/${company.id}/invoices/pay`;
  };

  if (!isOpen) {
    return null;
  }

  const renderSlideContent = () => {
    return (
      <>
        <p className="text-secondary-bg-primary">
          {isEea ? (
            t('international-wiretransfer.adoptionModal.eea.description')
          ) : (
            <ul className="list-inside list-disc [&_*]:pl-12">
              <Trans i18nKey="international-wiretransfer.adoptionModal.uk.description">
                <li>-</li>
                <li>-</li>
                <li>-</li>
                <li>-</li>
              </Trans>
            </ul>
          )}
        </p>
        {isEea && (
          <Box
            variant="secondary"
            className="text-primary mt-16 flex items-center gap-16"
          >
            <Avatar
              src="/static/img/avatars/Avatar_Men_Arabic_Glasses-Young.png"
              text="Happy Customer"
              size={40}
              variant="circle"
              className="flex-shrink-0"
            />
            <p>
              {t(
                'international-wiretransfer.adoptionModal.eea.customerSatisfaction',
              )}
            </p>
          </Box>
        )}
      </>
    );
  };

  return (
    <ModalSlideshow
      slides={[
        {
          title: isEea
            ? t('international-wiretransfer.adoptionModal.eea.title')
            : t('international-wiretransfer.adoptionModal.uk.title'),
          content: renderSlideContent(),
          illustration: (
            <img
              src="/static/img/internationalTransfers/globe.svg"
              alt="international wire transfer illustration"
            />
          ),
        },
      ]}
      translations={{
        cancel: isEea
          ? t('international-wiretransfer.adoptionModal.eea.notInterested')
          : t('international-wiretransfer.adoptionModal.uk.notInterested'),
        previous: t('misc.back'),
        next: t('misc.next'),
        done: t('international-wiretransfer.adoptionModal.tryItOut'),
      }}
      isOpen={isOpen}
      onCancel={() => {
        closeModal();
      }}
      onClose={() => {
        closeModal();
      }}
      onDone={() => {
        onDoneClick();
      }}
    />
  );
};
